export default __webpack_public_path__ + "static/media/logout.0defaa35.svg";